import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isLimitedEditionSelector, uploadWarningPopupContentSelector } from '../../../redux/product/product.selectors';
import { NoDesignPopup as NoDesignPopupComponent } from './no-design-popup';
const mapStateToProps = createStructuredSelector({
  uploadWarningPopupContent: uploadWarningPopupContentSelector,
  isLimitedEdition: isLimitedEditionSelector
});
export const NoDesignPopup = connect(mapStateToProps)(NoDesignPopupComponent);